<template>
  <ul class="sidebar-menu" @mouseenter="checkShowViewFont">
    <li class="header">MAIN NAVIGATION</li>
    <router-link tag="li" class="pageLink" to="/" v-show="$route.path == '/'">
      <a>
        <i class="fa fa-th"></i>
        <span class="page">Project</span>
      </a>
    </router-link>

    <li
      :class="$route.path === '/information'?'treeview active':'treeview'"
      v-show="isShowInformation"
    >
      <a class="version-manage">
        <i class="fa fa-file-text"></i>
        <span
          :class="isShowTreeViewFont?'pull-right-container':'pull-right-container hidden'"
        >Information</span>
        <span :class="isShowTreeViewFont?'pull-right-container':'pull-right-container hidden'">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <li :class="$route.path === '/information'?'active':''" v-show="isShowInformation">
          <router-link
            :to="{path:'/information/app?appid='+$route.query.appid+'&appname='+$route.query.appname}"
          >
            <i class="fa fa-adn"></i> App
          </router-link>
        </li>
        <li
          :class="$route.path === '/information/devicetypes'?'active':''"
          v-if="isAdminAndHasAppid"
        >
          <router-link
            :to="{
              path: '/information/devicetypes',
              query: {
                appid: $route.query.appid,
                appname: $route.query.appname,
              }
            }"
          >
            <i class="fa fa-tumblr"></i> DeviceTypes
          </router-link>
        </li>
        <li
          :class="$route.path === '/information/deviceaddon'?'active':''"
          v-if="isAdminAndHasAppid"
        >
          <router-link
            :to="{
              path: '/information/deviceaddon',
              query: {
                appid: $route.query.appid,
                appname: $route.query.appname,
              }
            }"
          >
            <i class="fa fa-puzzle-piece"></i> DeviceAddon
          </router-link>
        </li>
        <li
          :class="$route.path === '/information/deviceaddonclient'?'active':''"
          v-if="isAdminAndHasAppid"
        >
          <router-link
            :to="{
              path: '/information/deviceaddonclient',
              query: {
                appid: $route.query.appid,
                appname: $route.query.appname,
              }
            }"
          >
            <i class="fa fa-plug"></i> DeviceAddonClient
          </router-link>
        </li>
        <li
          :class="$route.path === '/information/apnsrelation'?'active':''"
          v-if="isAdminAndHasAppid"
        >
          <router-link
            :to="{
              path: '/information/apnsrelation',
              query: {
                appid: $route.query.appid,
                appname: $route.query.appname,
              }
            }"
          >
            <i class="fa fa-comment"></i> Apns Relation
          </router-link>
        </li>
      </ul>
    </li>

    <router-link tag="li" class="pageLink" to="/addapp" v-show="isShowAddApp">
      <a>
        <i class="fa fa-file-text"></i>
        <span class="page">Add App</span>
      </a>
    </router-link>

    <router-link
      tag="li"
      class="pageLink"
      :to="{path:'/agent?appid='+$route.query.appid+'&appname='+$route.query.appname}"
      v-show="isShowAdmin"
    >
      <a>
        <i class="fa fa-user"></i>
        <span class="page">Administrator</span>
      </a>
    </router-link>

    <router-link
      tag="li"
      class="pageLink"
      v-show="!isShowAboutDevice&&$route.path!='/'&&!isShowAddApp"
      :to="{path:'/device?appid='+$route.query.appid+'&appname='+$route.query.appname}"
    >
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">Device</span>
      </a>
    </router-link>

    <li id="devicetreeview" class="treeview active" v-show="isShowAboutDevice">
      <a @click="toDevice">
        <i class="fa fa-desktop"></i>
        <span
          :class="isShowTreeViewFont?'pull-right-container':'pull-right-container hidden'"
        >Device</span>
        <span :class="isShowTreeViewFont?'pull-right-container':'pull-right-container hidden'">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul id="devicetreemenu" class="treeview-menu active">
        <li :class="$route.path === '/aboutdevice'?'active':''">
          <router-link
            :to="{path:'/aboutdevice?appid='+$route.query.appid+'&appname='+$route.query.appname+'&devicename='+encodeURIComponent($route.query.devicename)+'&deviceid='+$route.query.deviceid+'&online='+$route.query.online+'&t='+$router.app.$store.state.devicetoken}"
          >
            <i class="fa fa-database active"></i> About Device
          </router-link>
        </li>
        <li :class="$route.path === '/parametersetting'?'active':''">
          <router-link
            :to="{path:'/parametersetting?appid='+$route.query.appid+'&appname='+$route.query.appname+'&devicename='+encodeURIComponent($route.query.devicename)+'&deviceid='+$route.query.deviceid+'&online='+$route.query.online+'&t='+$router.app.$store.state.devicetoken}"
          >
            <i class="fa fa-cog"></i> Parameter Setting
          </router-link>
        </li>
        <li :class="$route.path === '/eventlist'?'active':''" v-show="isAgentAdmin">
          <router-link
            :to="{path:'/eventlist?appid='+$route.query.appid+'&appname='+$route.query.appname+'&devicename='+encodeURIComponent($route.query.devicename)+'&deviceid='+$route.query.deviceid+'&online='+$route.query.online+'&t='+$router.app.$store.state.devicetoken}"
          >
            <i class="fa fa-list-ul"></i> Event List
          </router-link>
        </li>
        <li :class="$route.path === '/deviceupgrade'?'active':''" v-show="isAdminAndHasAppid">
          <router-link
            :to="{path:'/deviceupgrade?appid='+$route.query.appid+'&appname='+$route.query.appname+'&devicename='+encodeURIComponent($route.query.devicename)+'&deviceid='+$route.query.deviceid+'&online='+$route.query.online+'&t='+$router.app.$store.state.devicetoken}"
          >
            <i class="fa fa-upload"></i> Upgrade
          </router-link>
        </li>
        <li :class="$route.path === '/devicelog'?'active':''" v-show="isAdminAndHasAppid">
          <router-link
            :to="{path:'/devicelog?appid='+$route.query.appid+'&appname='+$route.query.appname+'&devicename='+encodeURIComponent($route.query.devicename)+'&deviceid='+$route.query.deviceid+'&online='+$route.query.online+'&t='+$router.app.$store.state.devicetoken}"
          >
            <i class="fa fa-file-code-o"></i> Log
          </router-link>
        </li>
        <li v-show="false">
          <router-link
            :to="{path:'/device?appid='+$route.query.appid+'&appname='+$route.query.appname+'&devicename='+encodeURIComponent($route.query.devicename)+'&deviceid='+$route.query.deviceid}"
          >
            <i class="fa fa-file-code-o"></i> Log
          </router-link>
        </li>
      </ul>
    </li>
    <router-link
      :class="$route.path === '/problemdevicelist'?'active':''"
      v-show="isShowProblemDevices"
      :to="{path:'/problemdevicelist?appid='+$route.query.appid+'&appname='+$route.query.appname+'&online='+$route.query.online+'&t='+$router.app.$store.state.devicetoken}"
      tag="li"
    >
      <a>
        <i class="fa fa-exclamation-triangle"></i>
        <span class="page">Problem Devices</span>
      </a>
    </router-link>
    <router-link
      tag="li"
      :class="$route.path === '/deviceuser'?'active pageLink':'pageLink'"
      :to="{path:'/deviceuser?appid='+$route.query.appid+'&appname='+$route.query.appname}"
      v-show="isShowUser"
    >
      <a>
        <i class="fa fa-users"></i>
        <span class="page">Device's Member</span>
      </a>
    </router-link>
    <router-link
      tag="li"
      :class="$route.path === '/accessory'?'active pageLink':'pageLink'"
      :to="{path:'/accessory?appid='+$route.query.appid+'&appname='+$route.query.appname}"
      v-show="isShowAccessory"
    >
      <a>
        <i class="fa fa-cubes"></i>
        <span class="page">Accessory</span>
      </a>
    </router-link>

    <router-link
      tag="li"
      class="pageLink"
      :to="{path:'/feedback?appid='+$route.query.appid+'&appname='+$route.query.appname}"
      v-show="isShowFeedback"
    >
      <a>
        <i class="fa fa-commenting"></i>
        <span class="page">Feedback</span>
      </a>
    </router-link>

    <router-link
      tag="li"
      class="pageLink"
      :to="{
        path: '/oauth2',
        query: {
          appid: $route.query.appid,
          appname: $route.query.appname,
        }
      }"
      v-if="isAdminAndHasAppid"
    >
      <a>
        <i class="fa fa-shield"></i>
        <span class="page">OAuth2</span>
      </a>
    </router-link>

    <router-link
      tag="li"
      class="pageLink"
      :to="{
        path: '/domain',
        query: {
          appid: $route.query.appid,
          appname: $route.query.appname,
        }
      }"
      v-if="isAdminAndHasAppid"
    >
      <a>
        <i class="fa fa-globe"></i>
        <span class="page">Domain</span>
      </a>
    </router-link>

    <!--数据分析-->
    <li :class="$route.path === '/analysis'?'treeview active':'treeview'" v-show="isShowAnalysis">
      <a class="version-manage">
        <i class="fa fa-bar-chart"></i>
        <span
          :class="isShowTreeViewFont?'pull-right-container':'pull-right-container hidden'"
        >Data Analysis</span>
        <span :class="isShowTreeViewFont?'pull-right-container':'pull-right-container hidden'">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <li
          :class="$route.path === '/analysis/testdeviceanalysis'?'active':''"
          v-show="isShowTestDeviceAnalysis"
        >
          <router-link
            :to="{path:'/analysis/testdeviceanalysis?appid='+$route.query.appid+'&appname='+$route.query.appname}"
          >
            <i class="fa fa-flask"></i> Test Device Analysis
          </router-link>
        </li>
        <li :class="$route.path === '/analysis/connection'?'active':''">
          <router-link
            :to="{
              path: '/analysis/connection',
              query: {
                appid: $route.query.appid,
                appname: $route.query.appname,
              }
            }"
          >
            <i class="fa fa-flask"></i> Connection Analysis
          </router-link>
        </li>
      </ul>
    </li>
    <!--数据分析-->
    <!-- 自动编译系统 -->
    <li
      id="roboottreeview"
      :class="$route.path === '/compilation'?'treeview active':'treeview'"
      v-show="hasAppId"
    >
      <a class="version-manage">
        <i class="fa fa-vimeo"></i>
        <span
          :class="isShowTreeViewFont?'pull-right-container':'pull-right-container hidden'"
        >Version Management</span>
        <span :class="isShowTreeViewFont?'pull-right-container':'pull-right-container hidden'">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul id="robottreemenu" class="treeview-menu">
        <li :class="$route.path === '/compilation/master'?'active':''" v-show="isShowCompilation">
          <router-link
            :to="{path:'/compilation/master?appid='+$route.query.appid+'&appname='+$route.query.appname+'&typeid=M0'}"
          >
            <i class="fa fa-arrow-circle-up"></i> Master
          </router-link>
        </li>
        <li :class="$route.path === '/compilation/android'?'active':''" v-show="isShowCompilation">
          <router-link
            :to="{path:'/compilation/android?appid='+$route.query.appid+'&appname='+$route.query.appname+'&typeid=M3'}"
          >
            <i class="fa fa-android"></i> Android
          </router-link>
        </li>
        <li :class="$route.path === '/compilation/ios'?'active':''" v-show="isShowCompilation">
          <router-link
            :to="{path:'/compilation/ios?appid='+$route.query.appid+'&appname='+$route.query.appname+'&typeid=M2'}"
          >
            <i class="fa fa-apple"></i> IOS
          </router-link>
        </li>
        <li
          :class="$route.path === '/compilation/robotlist'?'active':''"
          v-show="isShowCompilation"
        >
          <router-link
            :to="{path:'/compilation/robotlist?appid='+$route.query.appid+'&appname='+$route.query.appname}"
          >
            <i class="fa fa-simplybuilt"></i> Robot List
          </router-link>
        </li>
        <li :class="$route.path === '/compilation/mobileclientsupdatelogs'?'active':''">
          <router-link
            :to="{path:'/compilation/mobileclientsupdatelogs?appid='+$route.query.appid+'&appname='+$route.query.appname}"
          >
            <i class="fa fa-envelope"></i> Mobile Clients Update Logs
          </router-link>
        </li>
        <li :class="$route.path === '/compilation/masterslavesupdatelogs'?'active':''">
          <router-link
            :to="{path:'/compilation/masterslavesupdatelogs?appid='+$route.query.appid+'&appname='+$route.query.appname}"
          >
            <i class="fa fa-envelope"></i> Master / Slave Update Logs
          </router-link>
        </li>
        <li
          :class="$route.path === '/compilation/generalsetting'?'active':''"
          v-show="isShowCompilation"
        >
          <router-link
            :to="{path:'/compilation/generalsetting?appid='+$route.query.appid+'&appname='+$route.query.appname}"
          >
            <i class="fa fa-envelope"></i> Notification Settings
          </router-link>
        </li>
      </ul>
    </li>

    <router-link
      tag="li"
      class="pageLink"
      :to="{
        path: '/dinnewsweekly',
        query: {
          appid: $route.query.appid,
          appname: $route.query.appname,
        }
      }"
      v-if="isAdminAndHasAppid"
    >
      <a>
        <i class="fa fa-book"></i>
        <span class="page">News Weekly</span>
      </a>
    </router-link>
  </ul>
</template>
<script>
import utils from "../utils";

export default {
  name: "SidebarName",
  hasAppId: true,
  isShowInformation: true,
  isShowAddApp: true,
  // isShowAgent: true,
  isShowHost: true,
  isShowAccessory: true,
  isShowFeedback: true,
  isShowUser: true,
  isShowCompilation: true,
  data () {
    return {
      isShowTreeViewFont: true,
      isAgentAdmin: utils.checkIsAppAdmin()
    };
  },
  computed: {
    hasAppId () {
      return !!this.$route.query.appid;
    },
    isShowInformation: function () {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowAddApp: function () {
      if (this.$route.path === "/addapp") {
        return true;
      } else {
        return false;
      }
    },
    isShowAdmin () {
      return (
        typeof this.$route.query.appid !== "undefined" &&
        utils.checkIsAppAdmin()
      );
    },
    // isShowAgent: function () {
    //   console.log('this.$route.query.appid', this.$route.query.appid)
    //   return typeof this.$route.query.appid !== 'undefined'
    // },
    isShowHost: function () {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowAccessory: function () {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowFeedback: function () {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isAdminAndHasAppid: function () {
      return !!this.$route.query.appid && utils.checkIsAdmin();
    },
    isShowUser: function () {
      if (typeof this.$route.query.appid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowProblemDevices: function () {
      return this.$route.query.appid;
    },
    isShowAboutDevice: function () {
      if (typeof this.$route.query.deviceid !== "undefined") {
        window.jQuery("devicetreeview").addClass("active");
        window.jQuery("devicetreemenu").show();
        window.jQuery("devicetreemenu").addClass("active");
        return true;
      } else {
        return false;
      }
    },
    isShowAnalysis: function () {
      return utils.checkIsAppAdmin() && this.$route.query.appid;
    },
    isShowTestDeviceAnalysis: function () {
      this.isAgentAdmin = utils.checkIsAppAdmin();
      if (
        typeof this.$route.query.appid !== "undefined" &&
        this.isAgentAdmin !== false &&
        this.$route.query.appid === "2d2204507cd1399283847ac3fcd7f0c8"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isShowCompilation: function () {
      // 以后德国和alpha都会支持编译（但他们都只会在as上面才会有编译入口，如果去到各自的服务器，则不会有这个入口），所以这里不能隐藏，
      // if (process.env.APP_ENV === "develop-burg") return false;
      this.isAgentAdmin = utils.checkIsAppAdmin();
      return (
        typeof this.$route.query.appid !== "undefined" &&
        this.isAgentAdmin !== false &&
        this.$route.query.appid !== "88d79c29c7ce1bfd07f7afb7897511a7"
      );
    },
    isShowParamSetting: function () {
      if (typeof this.$route.query.deviceid !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    isShowLog: function () {
      if (typeof this.$route.query.deviceid !== "undefined") {
        return true;
      } else {
        return false;
      }
    }
  },
  created () {
    this.$bus.on("ShowTreeViewFont", this.checkShowViewFont);
  },
  beforeDestroy () {
    this.$bus.off("ShowTreeViewFont", this.checkShowViewFont);
  },
  mounted () { },
  methods: {
    toDevice () {
      this.$router.push(
        "/device?appid=" +
        this.$route.query.appid +
        "&appname=" +
        this.$route.query.appname
      );
    },
    checkShowViewFont () {
      if (window.jQuery("body").hasClass("sidebar-collapse")) {
        this.isShowTreeViewFont = false;
      } else {
        this.isShowTreeViewFont = true;
      }
    }
  }
};
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?37101d80